import { getDataSet, reduce } from "iso3166-2-db";

export function getCountries(langCode) {
  return Object.values(reduce(getDataSet(), langCode));
}
